import { Button } from "../../../../Common/AbstractComponents/Button";
import AjaxBuilder from "../../../../Common/AjaxBuilder";
import { Util } from "../../../../Common/Util";
import { AlertMessage } from "../../../CommonComponents/Insurance/AlertMessage";
import { Loader } from '../../../CommonComponents/Insurance/Loader';

export class ContinueBtn {
    constructor({ insuranceForm, state }) {
        this.$insuranceForm = insuranceForm;
        this.$route = this.$insuranceForm.data('checkout');
        this._state = state;

        this.$btn = this.$insuranceForm.find('#continue_btn');
        this._btn = new Button({
            button: this.$btn,
            onClick: this._continueOrder.bind(this),
        })
    }

    _continueOrder() {
        Loader.showLoader(this.$insuranceForm);
        new AjaxBuilder({
            route: this.$insuranceForm.data('save-cart'),
            data: {
                city: this._state.city,
                category: this._state.category,
                franchise: this._state.franchise,
                tariff: this._state.tariff,
                price: this._state.price
            },
            token: Util.token(),
        }, 'POST').execute({
            'success': () => {
                Loader.hideLoader(this.$insuranceForm);
                window.location = this.$route;
            },
            error: (error) => {
                console.log(error);
                AlertMessage.showMessage(error.responseJSON.message);
                Loader.hideLoader(this.$insuranceForm);
            }
        })
        
    }
}